export default __webpack_public_path__ + "static/media/eye-focus.bcf94ac3.svg";